export const CREATE_IP_WHITELIST_REQUEST = 'CREATE_IP_WHITELIST_REQUEST';
export const CREATE_IP_WHITELIST_SUCCESS = 'CREATE_IP_WHITELIST_SUCCESS';
export const CREATE_IP_WHITELIST_FAILED = 'CREATE_IP_WHITELIST_FAILED';

export const UPDATE_IP_WHITELIST_REQUEST = 'UPDATE_IP_WHITELIST_REQUEST';
export const UPDATE_IP_WHITELIST_SUCCESS = 'UPDATE_IP_WHITELIST_SUCCESS';
export const UPDATE_IP_WHITELIST_FAILED = 'UPDATE_IP_WHITELIST_FAILED';

export const GET_IP_WHITELIST_REQUEST = 'GET_IP_WHITELIST_REQUEST';
export const GET_IP_WHITELIST_SUCCESS = 'GET_IP_WHITELIST_SUCCESS';
export const GET_IP_WHITELIST_FAILED = 'GET_IP_WHITELIST_FAILED';

export const DELETE_IP_WHITELIST_REQUEST = 'DELETE_IP_WHITELIST_REQUEST';
export const DELETE_IP_WHITELIST_SUCCESS = 'DELETE_IP_WHITELIST_SUCCESS';
export const DELETE_IP_WHITELIST_FAILED = 'DELETE_IP_WHITELIST_FAILED';

export const SET_IP_WHITELIST = 'SET_IP_WHITELIST';
